
export const FETCH_LOT_CATEGORIES_BEGIN = 'FETCH_LOT_CATEGORIES_BEGIN'
export const FETCH_LOT_CATEGORIES_DONE = 'FETCH_LOT_CATEGORIES_DONE'
export const RECEIVE_LOT_CATEGORIES = 'RECEIVE_LOT_CATEGORIES'
export const RECEIVE_LOTS = 'RECEIVE_LOTS'
export const EMPTY_LOTS = 'EMPTY_LOTS'